<template>
  <div class="questionnaire-container">
    <div class='title'>{{ questionnaireTitle }}</div>
    <div class="content">
      <div
        v-for="(item, index) in questionnaireList"
        :key="index"
        class="question"
      >
        <span class='question-title'>
          <span class="iconfont iconquestion"></span>
          {{ item.title }}
        </span>
        <div class="video" v-if="item.type==='video'">
          <span class="iconfont iconanswer"></span>
          <div
            class='video-link'
            @click="handelVideoPop(item)"
            target="_blank">
            <img class="video-play-icon" :src="$DjangoStaticUrl('image/video/icon_video.png')" />
          </div>
        </div>
        <div class="attachment" v-if="item.type==='portfolio'">
          <span class="iconfont iconanswer"></span>
          <a
            class="attachment-tag"
            target="_blank"
            :href="item.private_download_attname_url"
          >
            {{ $t('hm.btn.download') }}
          </a>
        </div>
        <div class="answer">
          <span class="iconfont iconanswer"></span>
          {{ item.value }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  props: {
    questionnaireList: {
      require: true
    },
    questionnaireTitle: {
      require: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  beforeDestroy () {

  },
  methods: {
    handelVideoPop (item) {
      this.$emit('videoPop', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.questionnaire-container {

  >.title {
    padding: 10px 0 5px 10px;
    border-bottom: 1px solid #b4b4b4;
    font-size: 16px;
    font-weight: 600;
  }

  .content {
    padding: 10px;
    background-color: #FFFFFF;
    margin-top: 20px;

    .question {
      background: #f7f7f7;
      margin-bottom: 10px;
      padding: 10px;

      .iconfont {
        font-size: 30px;
        color: #b5b4b4;
      }

      &:last-child {
        margin-bottom: 0;
      }

      .question-title {
        display: flex;
        align-items: center;
      }

      .answer {
        margin: 10px 0;
        display: flex;
        align-items: center;
      }

      .video {
        display: flex;
        align-items: center;
        margin: 10px 0;

        .video-link {
          background-image: url($baseDomain + 'static/image/video/video_bg.png');
          background-size: 100% 100%;
          width: 120px;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;

          .video-play-icon {
            height: 36px;
          }
        }
      }

      .attachment {
        display: flex;
        align-items: center;

        .attachment-tag {
          color: #0096cc;
        }
      }
    }
  }
}
</style>
